import { ServiceSessionRecoveryEvent } from '@modules/ServiceModule';
import { InboxContext } from '../types';
import TasksModule from '@modules/TasksModule';
import { setCallWrapupTime } from '../callHandlers/callStateHandler';

function handleSessionRecoveryStarted(
  context: InboxContext,
  event: ServiceSessionRecoveryEvent,
) {
  const task = TasksModule.getTask(event.sessionSid);

  if (!task) {
    return;
  }

  if (context.userId === event.userId) {
    setCallWrapupTime(
      context,
      event.sessionSid,
      event.timestamp,
      event.recoveryAllowedMs,
    );
  }
}

export default handleSessionRecoveryStarted;
